/* Mini Cart (product added to cart pop-up) */

document.addEventListener("liquid-ajax-cart:request-end", function(event) {
   const {requestState, cart, previousCart, sections} = event.detail;

  if (requestState.requestType === 'change' && requestState.responseData?.ok) {
    const currentCart = cart.items || [];

    previousCart.items.forEach((prevItem) => {
      const stillExists = currentCart.some(currItem => currItem.key === prevItem.key);
      if (!stillExists) {
        document.querySelector(".minicart__header h2.removed .product").innerHTML = prevItem.title;
        document.querySelector(".minicart__header h2.title").classList.add("hidden");
        document.querySelector(".minicart__header h2.removed").classList.remove("hidden");
      }
    });
  }
  else {
    document.querySelector(".minicart__header h2.removed .product").innerHTML = "";
    document.querySelector(".minicart__header h2.title").classList.remove("hidden");
    document.querySelector(".minicart__header h2.removed").classList.add("hidden");
  }
});

/* Main cart Page */
class GiftWrappingButton extends HTMLElement {
  constructor() {
    super();

    this.addToCartButton = this.querySelector("button");

    if (this.addToCartButton) {
      if (this.addToCartButton.classList.contains("added")) {
        this.addToCartButton.addEventListener(
          "click",
          this.removeGiftWrap.bind(this)
        );
      } else {
        this.addToCartButton.addEventListener(
          "click",
          this.addGiftWrap.bind(this)
        );
      }
    }
  }

  addGiftWrap(event) {
    event.preventDefault();
    const giftID = this.addToCartButton.dataset.variant;
    const existingQty = this.addToCartButton.dataset.qty;
    const options = {
      lastComplete: (requestState) => {
        const notePopup = document.querySelector(".cart__note-popup");
        notePopup.classList.add("!flex");
        notePopup.removeAttribute("aria-hidden");
        window.scrollTo(0, 0);
        const first = notePopup.querySelector('button:not([disabled]), [href], input, textarea, [tabindex]:not([tabindex="-1"])');
        if (first) first.focus();
      },
    };

    if (window.liquidAjaxCart && giftID) {
      window.liquidAjaxCart.add(
        {
          id: giftID,
          quantity: existingQty
        },
        options
      );

      const parentProductKey = event.target
        .closest(".cart-item")
        .getAttribute("data-key");

      window.liquidAjaxCart.change(
        {
          id: parentProductKey,
          properties: {
            _giftwrap: true,
            _giftwrap_product_id: "4513841414234",
            _giftwrap_variant_id: "31757797458010",
          },
          quantity: existingQty,
        },
        options
      );
    }

    this.addToCartButton.classList.add("added");
    window.scrollTo(0, 0);
  }

  removeGiftWrap(event) {
    event.preventDefault();

    const giftWrapProduct = document.querySelector(".js-gift-wrap-product");
    const existingQty = this.addToCartButton.dataset.qty;
    const giftQty = giftWrapProduct.dataset.qty;
    const giftWrapProductKey = giftWrapProduct.dataset.key;
    const minusQty = giftQty - existingQty;
    const parentProductKey = event.target
      .closest(".cart-item")
      .getAttribute("data-key");
    const options = {
      lastComplete: (requestState) => {
        const notePopup = document.querySelector(".cart__note-popup");
        notePopup.classList.remove("!flex");
        notePopup.setAttribute("aria-hidden", "true");
        window.scrollTo(0, 0);
      },
    };

    window.liquidAjaxCart.change(
      {
        id: parentProductKey,
        properties: {
          _giftwrap: false,
          _giftwrap_product_id: "",
          _giftwrap_variant_id: "",
        },
        quantity: existingQty,
      },
      options
    );

    window.liquidAjaxCart.change(
      {
        id: giftWrapProductKey,
        quantity: minusQty,
      },
      options
    );

    this.addToCartButton.classList.remove("added");
    window.scrollTo(0, 0);
  }
}

customElements.define("gift-wrapping-atc", GiftWrappingButton);

const FOCUSABLE_SELECTORS = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',');

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.openTrigger = document.querySelector(".js-open-cart-note");
    this.notePopup = document.querySelector(".cart__note-popup");
    this.closeButtons = document.querySelectorAll(".js-close-popup");

    this._handleKeydown = this._handleKeydown.bind(this);

    if (this.openTrigger) {
      this.openTrigger.addEventListener("click", () => this._openPopup());
    }

    this.closeButtons.forEach((btn) => {
      btn.addEventListener("click", () => this._closePopup());
    });
  }

  _openPopup() {
    this.notePopup.classList.add("!flex");
    this.notePopup.removeAttribute("aria-hidden");
    window.scrollTo(0, 0);

    const firstFocusable = this.notePopup.querySelector(FOCUSABLE_SELECTORS);
    if (firstFocusable) firstFocusable.focus();

    document.addEventListener("keydown", this._handleKeydown);
  }

  _closePopup() {
    this.notePopup.classList.remove("!flex");
    this.notePopup.setAttribute("aria-hidden", "true");
    window.scrollTo(0, 0);

    document.removeEventListener("keydown", this._handleKeydown);

    if (this.openTrigger) this.openTrigger.focus();
  }

  _handleKeydown(event) {
    if (event.key === "Escape") {
      this._closePopup();
      return;
    }

    if (event.key !== "Tab") return;

    const focusable = Array.from(this.notePopup.querySelectorAll(FOCUSABLE_SELECTORS));
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey) {
      if (document.activeElement === first) {
        event.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }
}

customElements.define("cart-note", CartNote);
